import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BaasAppState, BaasAuthService } from '@lvflanders/bar';
import { BarCoreService } from '@lvflanders/bar-ng';

/** Widget injected into burgerprofiel header in case impersonating (tech page). */
@Component({
    templateUrl: './bar-impersonation-widget.component.html',
    standalone: false
})
export class BarImpersonationWidgetComponent implements OnInit {
    readonly #auth = inject(BaasAuthService);
    readonly #state = inject(BaasAppState);
    readonly #coreState = inject(BarCoreService);
    readonly #destroyRef = inject(DestroyRef);

    content: string;

    ngOnInit() {
        this.content = this.#state.basiscontext?.fullUsername;
        this.#coreState.basiscontextChanged.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((basiscontext) => {
            this.content = basiscontext?.fullUsername;
        });
    }

    logOff(): void {
        this.#auth.logOff();
    }
}
